export default (process?.env?.VUE_APP_WHITE_LABEL || '') === 'true'
